import React, { useState, useEffect, Fragment } from 'react';
import { Link, withRouter, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Tooltip, Drawer, Modal, Button,
  Popover,
} from 'antd';
import Helpers from '@Apis/helpers';
import { QUANTITY, toISTDate } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import './style.scss';
import closeIcon from '@Images/icons/icon-close-blue.png';
import MrpV2Actions from '@Actions/production/mrpV2Actions';
import dayjs from 'dayjs';
import H3Progress from '@Components/Common/H3Progress';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faLink } from '@fortawesome/free-solid-svg-icons';
import LinkManufacturingOrderMrp from './LinkManufacturingOrderMrp';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';

function ProductionOrders({
  user, getLinkedMO, getLinkedMOLoading, linkedMO, getStockItems, getLinkedMOSuccess, getStockItemsSuccess, callForMO, setCallForMO,
  pushToProductionItemsLoading, pushToStockItemsLoading, updateMrpV2Loading, getMrpV2, match, mrpData, unlinkMoToMrp, unlinkMoToMrpLoading,
  call
}) {
  const [showLinkMoMrp, setShowLinkMoMrp] = useState(false);
  const [selectedProductionItemRows, setSelectedProductionItemRows] = useState([]);

  // Production Items
  const [selectedProductionItemRowKeys, setSelectedProductionItemRowKeys] = useState([]);
  const [callProdctionItem, setCallProdctionItem] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  // Stock Items
  const [callStockItem, setCallStockItem] = useState(false);
  const [consolidateStockItems, setConsolidateStockItems] = useState(false);
  const [ignoreStockItemsAvailableStock, setIgnoreStockItemsAvailableStock] = useState(false);
  const [ignoreStockItemsSafetyStock, setIgnoreStockItemsSafetyStock] = useState(false);
  const [ignoreStockItemsReservedStock, setIgnoreStockItemsReservedStock] = useState(false);

  const location = useLocation();

  const mrpId = match.params?.mrpId;

  useEffect(() => {
    getMrpV2({
      tenantId: mrpData?.tenant_id,
      listScreen: false,
      mrpId: Number(mrpId),
    }, (mrpV2Data) => {
      // Stock Items
      setConsolidateStockItems(mrpV2Data?.consolidate_requirement_mrp_stock_items);
      setIgnoreStockItemsAvailableStock(mrpV2Data?.ignore_available_stock_mrp_stock_items);
      setIgnoreStockItemsSafetyStock(mrpV2Data?.ignore_safety_stock_mrp_stock_items);
      setIgnoreStockItemsReservedStock(mrpV2Data?.ignore_reserved_stock_mrp_stock_items);
    });

    const tab = location.search?.split('=')?.[1];
    if (tab === 'production_orders') {
      setCallProdctionItem(!callProdctionItem);
      setCallStockItem(!callStockItem);
    }
  }, [location.search, callForMO]);

  useEffect(() => {
    if (Number(mrpId)) {
      getLinkedMO({ mrpId: Number(mrpId) });
    }

    return () => {
      getLinkedMOSuccess(null);
    };
  }, [callProdctionItem, mrpId, call]);

  useEffect(() => {
    getStockItems({ mrpId: Number(mrpId), entityType: 'RAW_MATERIAL' });

    return () => {
      getStockItemsSuccess(null, 'RAW_MATERIAL');
    };
  }, [callStockItem]);

  const getMoStockStatusColor = (status) => {
    if (status === 'PENDING_FROM_VENDOR') return '#2d7cf7';
    if (status === 'READY_TO_PRODUCE') return 'rgb(40, 197, 77)';
    if (status === 'AVAILABLE') return 'rgb(40, 197, 77)';
    if (status === 'RESERVED') return 'rgb(40, 197, 77)';
    if (status === 'UNAVAILABLE') return '#ff4d4f';
    return '#f68d16';
  };

  const getCreatedProductionOrderColumns = () => {
    const moListColumns = [
      {
        title: 'Order #',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        fixed: 'left',
        width: '150px',
        render: (record) => (
          <Fragment>
            <Tooltip title={(
              <div>
                {record?.linked_sales_orders?.length > 0 && (
                  <Link
                    to={`/sales/sales-order/view/${record?.linked_sales_orders?.[0]?.order_id}`}
                    target="_blank"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      fontSize: '10px',
                      fontWeight: '500',
                      marginTop: '5px',
                      color: 'white',
                    }}
                  >
                    <FontAwesomeIcon icon={faLink} />
                    <span>{record?.linked_sales_orders?.[0]?.sales_order_number}</span>
                  </Link>
                )}
                {
                record?.seller_name ? (
                  <Fragment>
                    <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
                      <span style={{ fontWeight: '600' }}>{record?.seller_name}</span>
                    </Link>
                    {record?.seller_address ? <H3Text text={record?.seller_address?.city} /> : ''}
                  </Fragment>
                ) : ''
                }
              </div>
            )}
            >
              <Link
                to={`/production/manufacturing-orders/view/${record?.mo_id}`}
                target="_blank"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  fontSize: '12px',
                  fontWeight: '500',
                  marginTop: '5px',
                }}
              >
                <H3Text text={record?.mo_number} />
              </Link>
            </Tooltip>
          </Fragment>
        ),
      },
      {
        title: 'Finished Good',
        width: '250px',
        render: (item) => {
          const { mo_finished_goods } = item;
          return (
            <Fragment>
              {
                mo_finished_goods?.map((rec) => (
                  <Popover 
                  content={(
                    <div style={{
                      maxHeight: '150px',
                      overflowY: 'auto',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '4px',
                      padding: '4px',
                    }}
                    >
                      {`${rec?.internal_sku_code || ''} - ${rec?.product_sku_name || ''} ${rec?.uom_info?.uqc?.toProperCase()}`}<br/>
                      {rec?.category_path?.length > 0 && (
                        <ProductCategoryLabel
                          categoryPath={rec?.category_path}
                          categoryName={rec?.category_path?.at(-1)}
                          containerStyle={{
                            width: "fit-content",
                          }}
                        />
                      )}
                    </div>
                  )}
                  trigger="hover" 
                  placement="bottomLeft"
                >
                  {rec?.product_sku_name ? (
                    <div className="material-shortage-sku-name">
                      <Link to={`/inventory/product/view/${rec?.product_sku_id}`} target="_blank">
                        {`#${rec?.internal_sku_code}`}
                      </Link>
                      <span>
                        {` - ${rec?.ref_product_code ? `${rec?.ref_product_code} - ` : ''}${rec?.product_sku_name}`}
                      </span>
                    </div>
                  ) : '-'}
                </Popover>
                ))
              }
            </Fragment>
          );
        },
        responsive: ['md', 'lg', 'xxl'],
      },
      {
        title: 'Start Date',
        render: (text, record) => toISTDate(record?.scheduled_date).format('DD/MM/YYYY'),
        responsive: ['md', 'lg', 'xxl'],
      },
      // {
      //   title: 'Completion Date',
      //   render: (text, record) => (record?.completed_at ? toISTDate(record?.scheduled_date).format('DD/MM/YYYY') : '-'),
      //   responsive: ['md', 'lg', 'xxl'],
      // },
      {
        title: 'Status',
        render: (item) => (
          <div className="mo__status" style={{ color: Helpers.getStatusColor(item.status).color, fontWeight: '600' }}>
            {Helpers.getStatusColor(item.status).text?.toUpperCase()}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Availability',
        render: (text, record) => (
          <div>
            <H3Progress percent={record?.raw_material_availability_absolute_percentage} barWidth={50} />
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
      },
      {
        title: 'Reservation',
        render: (text, record) => (
          <div>
            <H3Progress percent={record?.raw_material_reserved_percentage} barWidth={50} />
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
      },
      {
        title: 'Expected Materials Arrival',
        render: (text, record) => (
          <div className="production-orders__table-date-tick">
            {record?.edd ? dayjs(record?.edd).format('DD-MMM-YYYY').toUpperCase() : '-'}
            {record?.edd && record?.raw_material_reserved_percentage >= 100 && <FontAwesomeIcon icon={faCircleCheck} color="rgb(40, 197, 77)" />}
            {record?.edd && record?.stock_status === 'PENDING_FROM_VENDOR' && (
              <Fragment>
                {
                  (dayjs().format('DD-MM-YYYY') === dayjs(record?.edd).format('DD-MM-YYYY'))
                    ? (<div className="status-tag" style={{ backgroundColor: '#f68d16' }}>AT RISK</div>) : (dayjs().isAfter(dayjs(record?.edd)) ? <div className="status-tag" style={{ backgroundColor: getMoStockStatusColor('UNAVAILABLE') }}>DELAYED</div> : '')
                }
              </Fragment>
            )}
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
      },
      {
        title: 'Stock Status',
        render: (text, record) => (
          <div className="production-orders__table-stock-status-inner" style={{ backgroundColor: getMoStockStatusColor(record?.stock_status) }}>
            {record?.stock_status?.replaceAll('_', ' ')}
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
        className: 'production-orders__table-stock-status',
      },
    ];
    return moListColumns;
  };

  const getStockItemsColumns = () => {
    const mrpColumns = [
      {
        title: 'SKU#',
        fixed: 'left',
        render: (record) => (
          <div style={{ width: '250px' }}>
            <div style={{ display: 'flex' }}>
              <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
                {`#${record?.internal_sku_code}`}
              </Link>
            </div>
            <div>
              {`${record?.ref_product_code ? `${record?.ref_product_code} - ` : ''}${record?.product_sku_name}`?.trim()}
            </div>
            {record?.order_id && (
              <div style={{ display: 'flex' }}>
                <Link to={`/production/manufacturing-orders/view/${record?.mo_id}`} target="_blank">
                  {record?.mo_number}
                </Link>
              </div>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'MO#',
        render: (record) => (
          <Fragment>
            <Link to={`/production/manufacturing-orders/view/${record?.mo_id}`} target="_blank">
              {record?.mo_number}
            </Link>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'REQUIRED QTY',
        render: (record) => (
          <div>{`${QUANTITY(record?.demand_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'CONSUMED QTY',
        render: (record) => (
          <div>{`${QUANTITY(record?.issued_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'RESERVED QTY',
        render: (record) => (
          <div>{`${QUANTITY(record?.so_line_reserved_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'PURCHASED QTY',
        render: (record) => (
          <div>{`${QUANTITY(record?.created_mo_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'AVAILABLE QTY',
        render: (record) => (
          <div>
            {`${QUANTITY(record?.available_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'THRESHHOLD QTY',
        render: (record) => (
          <div>
            {`${QUANTITY(record?.threshold_qty || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'TO BE ORDERED',
        fixed: 'right',
        render: (record) => (
          <div>{`${QUANTITY(record?.pending_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
    ];

    return mrpColumns;
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleUnlinkSO = () => {
    // Handle unlink SO without freeing batches
    processUnlink({ free_reserved_batch: false });
    setIsModalVisible(false);
  };

  const handleUnlinkWithBatches = () => {
    // Handle unlink SO and free batches
    processUnlink({ free_reserved_batch: true });
    setIsModalVisible(false);
  };

  const processUnlink = ({ free_reserved_batch }) => {
    const payload = {
      mrp_id: mrpData?.mrp_id,
      mo_ids: selectedProductionItemRowKeys?.join(','),
      free_reserved_batch,
    };
    unlinkMoToMrp(payload, () => {
      setSelectedProductionItemRowKeys([]);
      setSelectedProductionItemRows([]);
      setCallStockItem(!callStockItem);
      setCallProdctionItem(!callProdctionItem);
      setIsModalVisible(false);
      setCallForMO();
    });
  };

  return (
    <Fragment>
      <Modal
        title="Remove Manufacturing Orders"
        open={isModalVisible}
        onCancel={handleCancel}
        closable
        footer={false}
      >
        <p>Do you also want to free reserved batches for selected manufacturing orders?</p>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Button
            key="unlink"
            onClick={handleUnlinkSO}
            disabled={unlinkMoToMrpLoading}
            style={{ marginBottom: '10px' }}
          >
            Remove Without Clearing Reservations
          </Button>
          <Button
            key="unlinkBatch"
            onClick={handleUnlinkWithBatches}
            type="primary"
            disabled={unlinkMoToMrpLoading}
            style={{ marginBottom: '10px' }}
          >
            Remove and Clear Reservations
          </Button>
          <Button
            key="back"
            onClick={handleCancel}
            disabled={unlinkMoToMrpLoading}
          >
            Cancel
          </Button>
        </div>
      </Modal>
      <Drawer
        width="1080px"
        title="Basic Drawer"
        placement="right"
        onClose={() => setShowLinkMoMrp(false)}
        open={showLinkMoMrp}
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
            style={{
              position: 'static',
              width: '1035px',
            }}
          >
            <H3Text
              text="Add Production Orders to this Materials Plan"
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setShowLinkMoMrp(false)}
            />
          </div>
          <LinkManufacturingOrderMrp
            mrpId={mrpId}
            tenantId={mrpData?.tenant_id}
            callback={() => {
              setShowLinkMoMrp(false);
              setCallStockItem(!callStockItem);
              setCallProdctionItem(!callProdctionItem);
              setCallForMO();
            }}
          />
        </div>
      </Drawer>
      <div className="production-orders__wrapper">

        <div className="production-orders__upper-wrapper">
          <div className="production-orders__table">
            <div className="production-orders__table-title__button-wrapper">
              <Button
                type="primary"
                onClick={() => {
                  setShowLinkMoMrp(true);
                }}
                disabled={mrpData?.status === 'CLOSED'}
              >
                + Add Production Order
              </Button>
              &nbsp;
              &nbsp;
              <Button
                onClick={showModal}
                disabled={selectedProductionItemRowKeys.length === 0}
                danger
              >
                Unlink Production Orders
              </Button>
            </div>
            <Table
              key={1}
              // title={() => (
              //   <div className="production-orders__table-title__wrapper">
              //     <div className="production-orders__table-title">
              //       <H3Text text={linkedMO?.count || '0'} className="production-orders__table-title-count" />
              //       &nbsp;Production Orders
              //     </div>
              //   </div>
              // )}
              bordered
              loading={getLinkedMOLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading || unlinkMoToMrpLoading}
              showHeader
              size="small"
              // scroll={{ y: 'calc(100dvh - 290px)' }}
              columns={getCreatedProductionOrderColumns()}
              dataSource={linkedMO?.manufacturing_orders ? linkedMO?.manufacturing_orders?.map((item) => ({
                ...item,
                key: item?.mo_id,
              })) : []}
              pagination={false}
              rowSelection={(window.screen.width > 425) ? {
                onChange: (rowKeys, rows) => {
                  setSelectedProductionItemRowKeys(rowKeys);
                  setSelectedProductionItemRows(rows);
                },
                selectedProductionItemRowKeys,
              } : false}
            />
          </div>
        </div>

        {/* <div className="production-orders__lower-wrapper">
          <div className="production-orders__checkbox-wrapper">
            <div className="ant-row">
              <div className="ant-col-md-24">
                <div>
                  <Checkbox
                    checked={consolidateStockItems}
                    onChange={(e) => {
                      setConsolidateStockItems(e.target.checked);
                      updateMrpV2({
                        mrp_id: mrpId,
                        consolidate_requirement_mrp_stock_items: e.target.checked,
                      }, () => setCallStockItem(!callStockItem));
                    }}
                    disabled={getLinkedMOLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading}
                  >
                    Consolidate Requirement
                  </Checkbox>
                </div>
              </div>
              <div className="ant-col-md-24">
                <div>
                  <Checkbox
                    checked={ignoreStockItemsAvailableStock}
                    onChange={(e) => {
                      setIgnoreStockItemsAvailableStock(e.target.checked);
                      updateMrpV2({
                        mrp_id: mrpId,
                        ignore_available_stock_mrp_stock_items: e.target.checked,
                      }, () => setCallStockItem(!callStockItem));
                    }}
                    disabled={getLinkedMOLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading}
                  >
                    Ignore Available Stock
                  </Checkbox>
                </div>
              </div>
              <div className="ant-col-md-24">
                <div>
                  <Checkbox
                    checked={ignoreStockItemsSafetyStock}
                    onChange={(e) => {
                      setIgnoreStockItemsSafetyStock(e.target.checked);
                      updateMrpV2({
                        mrp_id: mrpId,
                        ignore_safety_stock_mrp_stock_items: e.target.checked,
                      }, () => setCallStockItem(!callStockItem));
                    }}
                    disabled={getLinkedMOLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading}
                  >
                    Ignore Safety Stock
                  </Checkbox>
                </div>
              </div>
              <div className="ant-col-md-24">
                <div>
                  <Checkbox
                    checked={ignoreStockItemsReservedStock}
                    onChange={(e) => {
                      setIgnoreStockItemsReservedStock(e.target.checked);
                      updateMrpV2({
                        mrp_id: mrpId,
                        ignore_reserved_stock_mrp_stock_items: e.target.checked,
                      }, () => setCallStockItem(!callStockItem));
                    }}
                    disabled={getLinkedMOLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading}
                  >
                    Ignore Reserved Stock
                  </Checkbox>
                </div>
              </div>
            </div>
          </div>
          <div className="production-orders__table">
            <Table
              key={2}
              title={() => (
                <div className="production-orders__table-title__wrapper">
                  <H3Text text={`${stockItemsRM?.count || '0'} Stock Item(s) (Raw Materials)`} className="" />
                  <H3Button
                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                    text="Move To Shortage"
                    onClick={() => {
                      pushToStockItems({
                        mrp_id: mrpId,
                        order_line_ids: consolidateProductionItems ? selectedProductionItemRows?.map((item) => item?.lines?.map((line) => line?.order_line_id))?.flat() : selectedProductionItemRowKeys,
                      }, () => {
                        setCallProdctionItem(!callProdctionItem);
                        setCallStockItem(!callStockItem);
                        setSelectedProductionItemRowKeys([]);
                        setSelectedStockItemRowKeys([]);
                        setSelectedProductionItemRows([]);
                      });
                    }}
                    customClass="mrp__add-button"
                    disabled={selectedProductionItemRows?.length === 0}
                  />
                </div>
              )}
              bordered
              loading={getStockItemsRMLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading}
              showHeader
              size="small"
              scroll={{ x: 'max-content' }}
              columns={consolidateStockItems ? getStockItemsColumns()?.filter((item) => !['SO#',].includes(item.title)) : getStockItemsColumns()?.filter((item) => !['SO#',].includes(item.title))}
              dataSource={stockItemsRM?.data ? stockItemsRM?.data?.map((item) => ({
                ...item,
                key: consolidateStockItems ? item?.product_sku_id : (item?.order_line_id || item?.mo_line_id),
              })) : []}
              pagination={false}
              rowClassName={(rec) => (rec?.is_material_available ? '' : 'production-orders__short-row')}
              expandable={consolidateStockItems && {
                expandedRowRender: (record) => {
                  return (
                    <div className="batch-selector-wrapper">
                      <H3Text text="Order Lines" className="batch-selector-title" />
                      <Table
                        bordered
                        size="small"
                        scroll={{ x: 'max-content' }}
                        columns={getStockItemsColumns()?.filter((item) => !['', 'SKU#',].includes(item.title))}
                        dataSource={record?.lines ? record?.lines?.map((item) => ({
                          ...item,
                          key: item?.order_line_id,
                        })) : []}
                        pagination={false}
                      />
                    </div>
                  );
                },
                rowExpandable: (record) => record?.lines?.length > 0,
              }}
            />
          </div>
        </div> */}

      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, MrpV2Reducers,
}) => ({
  user: UserReducers.user,
  getLinkedMOLoading: MrpV2Reducers.getLinkedMOLoading,
  pushToProductionItemsLoading: MrpV2Reducers.pushToProductionItemsLoading,
  getStockItemsRMLoading: MrpV2Reducers.getStockItemsRMLoading,
  pushToStockItemsLoading: MrpV2Reducers.pushToStockItemsLoading,
  updateMrpV2Loading: MrpV2Reducers.updateMrpV2Loading,
  linkedMO: MrpV2Reducers.linkedMO,
  stockItemsRM: MrpV2Reducers.stockItemsRM,
  updateMrpProductionLoading: MrpV2Reducers.updateMrpProductionLoading,
  getMrpV2Loading: MrpV2Reducers.getMrpV2Loading,
  mrpV2: MrpV2Reducers.mrpV2,
  unlinkMoToMrpLoading: MrpV2Reducers.unlinkMoToMrpLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getMrpV2: (payload, callback) => dispatch(MrpV2Actions.getMrpV2(payload, callback)),
  getLinkedMO: (payload, callback) => dispatch(MrpV2Actions.getLinkedMO(payload, callback)),
  getLinkedMOSuccess: (linkedMO) => dispatch(MrpV2Actions.getLinkedMOSuccess(linkedMO)),
  getStockItems: (payload, callback) => dispatch(MrpV2Actions.getStockItems(payload, callback)),
  getStockItemsSuccess: (stockItemsRM, entityType) => dispatch(MrpV2Actions.getStockItemsSuccess(stockItemsRM, entityType)),
  pushToProductionItems: (payload, callback) => dispatch(MrpV2Actions.pushToProductionItems(payload, callback)),
  pushToStockItems: (payload, callback) => dispatch(MrpV2Actions.pushToStockItems(payload, callback)),
  updateMrpV2: (payload, callback) => dispatch(MrpV2Actions.updateMrpV2(payload, callback)),
  updateMrpProduction: (payload, callback) => dispatch(MrpV2Actions.updateMrpProduction(payload, callback)),
  unlinkMoToMrp: (payload, callback) => dispatch(MrpV2Actions.unlinkMoToMrp(payload, callback)),
});

ProductionOrders.propTypes = {
  user: PropTypes.any,
  linkedMO: PropTypes.any,
  stockItemsRM: PropTypes.any,
  getLinkedMO: PropTypes.func,
  getStockItems: PropTypes.func,
  getLinkedMOLoading: PropTypes.bool,
  getStockItemsRMLoading: PropTypes.bool,
  getMrpV2: PropTypes.func,
  getMrpV2Loading: PropTypes.bool,
  mrpV2: PropTypes.any,
  match: PropTypes.any,
  mrpData: PropTypes.any,
  pushToProductionItems: PropTypes.func,
  pushToProductionItemsLoading: PropTypes.bool,
  pushToStockItems: PropTypes.func,
  pushToStockItemsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductionOrders));
